import { EnvelopeIcon } from 'pages/signup/components/EnvelopeIcon';
import {
    ConfirmationBox,
    Container,
    ContentWrapper,
    InformationBox,
} from './style';
import { GivelifyLabel } from '@givelify/ui';
import { Footer } from './Footer';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

type ContentProps = {
    onResend: () => void;
    onSupport: () => void;
    email: string;
};

export const Content: React.FC<ContentProps> = ({
    onResend,
    onSupport,
    email,
}) => {
    const { t } = useTranslation();
    const copy = useMemo(
        () => ({
            almostThere: t('signup.submitted.almostThere'),
            confirmEmail: t('signup.submitted.confirmEmail'),
            weSent: t('signup.submitted.weSent'),
            checkInbox: t('signup.submitted.checkInbox'),
        }),
        [t],
    );
    return (
        <ContentWrapper>
            <Container>
                <EnvelopeIcon />
                <InformationBox>
                    <GivelifyLabel
                        className="info signed-up"
                        text={copy.almostThere}
                    />
                    <GivelifyLabel
                        className="info check-email"
                        text={copy.confirmEmail}
                    />
                </InformationBox>
                <ConfirmationBox>
                    <GivelifyLabel text={copy.checkInbox} className="text" />
                    <GivelifyLabel text={email} className="email" />
                </ConfirmationBox>
            </Container>
            <Footer onResend={onResend} onSupport={onSupport} />
        </ContentWrapper>
    );
};
